// Texty a čtení názvů metod dopravy/plateb (shippingModel.js) — sdílí je pokladna,
// modal „Možnosti doručení", stránka Doprava a platba i škála hmotnosti.
import { NBSP } from '../../modules/money.js';
import D from './dispatchEta.js';

export default {
  // --- skupiny dopravy ---
  boxTitle: 'Výdejní místa a boxy',
  boxDesc: 'Síť výdejních míst po celé ČR',
  /** název metody → skupina výdejních míst (čte text Shoptetu) */
  boxRe: /z-?box|z[áa]silkovn|bal[íi]kovn|parcel\s?shop|parcelshop|v[ýy]dejn|pickup|depo|alzabox|v[ýy]dejov/i,
  addressTitle: 'Doprava na adresu',
  addressDesc: 'Doručení přímo na vaši adresu',
  pickupTitle: 'Osobní odběr na prodejně Jipos',
  pickupDesc: 'Prodejna Jipos Bílina, Teplická 906',
  /** název metody → osobní odběr */
  pickupRe: /osobn[íi]\s*odb[ěe]r|prodejn/i,
  /** název metody → nadrozměrná přeprava */
  oversizeRe: /nadrozm[ěe]r|nadm[ěe]r|atypick/i,
  oversizeNote:
    'Zboží v košíku přesahuje limity pro výdejní místa i běžnou dopravu na adresu, ' +
    'objednávku proto veze nadrozměrná přeprava.',
  oversizeNoteProduct:
    'Produkt přesahuje limity pro výdejní místa i běžnou dopravu na adresu, ' + 'proto ho veze nadrozměrná přeprava.',

  // --- osobní odběr ---
  mapLabel: 'Zobrazit na mapě',
  stockNote: 'Zboží skladem si můžete vyzvednout bez dlouhého čekání. Stačí na prodejně nahlásit číslo objednávky a během pár minut vám ho přineseme ze skladu.',
  days: D.days,
  today: D.today,
  tomorrow: D.tomorrow,
  openUntil: (hour) => 'Právě otevřeno, vyzvednout můžete ještě dnes do ' + hour,
  closed: 'Zavřeno',
  closedOpens: (when, hour) => 'Zavřeno, otevíráme ' + when + ' v ' + hour,
  hoursLabel: 'Otevírací doba',
  freeShipScope: 'na výdejní místo',

  // --- ceník /doprava-platba/ ---
  boxRowName: (carrier) => carrier + ' na výdejní místo',
  addrRowName: (carrier) => carrier + ' na adresu',
  addrRowDesc: 'kurýr v den doručení zavolá',
  glsBoxDesc: (kg) => 'do ' + kg + NBSP + 'kg (limit dopravce), výdejní místa i boxy',
  pplBoxDesc: (kg) => 'do ' + kg + NBSP + 'kg (limit dopravce), Parcelshop i Parcelbox',
  oversizeName: 'PPL – Nadrozměrné zásilky',
  oversizeDesc: 'jen atypické zboží označené v košíku',
  fofrName: 'Fofr – Nadměrné balíky',
  fofrDesc: 'jen na adresu',
  pickupName: 'Osobní odběr',

  // --- hmotnost a pásma ---
  kg: 'kg',
  bandUpTo: 'do',
  bandOver: 'nad',
  chipLead: 'Zásilka ',
  scaleTitle: 'Hmotnost zásilky a cena dopravy',
  scaleBox: 'Výdejní místo',
  scaleAddr: 'Na adresu',
  scaleNoteA: (maxKg, scope) => 'Do ' + maxKg + NBSP + 'kg ' + scope + ' zdarma při nákupu nad ',
  scaleOverLabel: 'Přeprava pro nadměrné balíky',
  footOver: (lastKg) => 'Zásilka nad ' + lastKg + NBSP + 'kg jde přepravou pro nadměrné balíky.',
  productA: 'Produkt váží ',
  productB: ', ceny níže platí pro pásmo ',
  productSum: 'V košíku se hmotnost položek sčítá',
  productFreeA: (maxKg) => '; do ' + maxKg + NBSP + 'kg a nad ',
  productFreeB: ' je výdejní místo zdarma.',

  // --- ikony plateb podle názvu metody (čte text Shoptetu) ---
  payCashRe: /dob[íi]rk/i,
  payBankRe: /p[řr]evod|qr|bank/i,
  payWalletRe: /hotov[ěe]|prodejn|pokladn/i,
  payCardRe: /kart|online|shoptet\s*pay|apple|google|gopay|comgate/i,
};
